import { useTranslation } from 'react-i18next';
import { NavLink, Outlet } from 'react-router-dom';
import styles from './Admin.module.css';

/** Rahmen der Administration mit Reitern Benutzer, Wettbewerbsliste, Login-Protokoll und Audit-Protokoll. */
export function AdminLayout() {
  const { t } = useTranslation();
  /** Klassen eines Reiters: Grundstil plus Hervorhebung, wenn aktiv. */
  const tabClass = ({ isActive }: { isActive: boolean }) =>
    [styles.tab, isActive ? styles.tabActive : null].filter(Boolean).join(' ');
  return (
    <section>
      <h1>{t('admin.title')}</h1>
      <nav aria-label={t('admin.title')} className={styles.tabs}>
        <NavLink to="/admin/benutzer" className={tabClass}>
          {t('admin.tabUsers')}
        </NavLink>
        <NavLink to="/admin/wettbewerbsliste" className={tabClass}>
          {t('admin.tabSalons')}
        </NavLink>
        <NavLink to="/admin/protokoll" className={tabClass}>
          {t('admin.tabLog')}
        </NavLink>
        <NavLink to="/admin/audit" className={tabClass}>
          {t('admin.tabAudit')}
        </NavLink>
        <NavLink to="/komponenten" className={tabClass}>
          {t('nav.components')}
        </NavLink>
      </nav>
      <Outlet />
    </section>
  );
}
